var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", [
    _c(
      "div",
      {
        staticClass: "modal modal-plant_detail fade",
        class: { "show d-block": _vm.show },
        attrs: { tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _vm.plantDetails
              ? _c("div", { staticClass: "modal-content p-0" }, [
                  _c("div", { staticClass: "modal-header p-0" }, [
                    _c(
                      "a",
                      {
                        staticClass: "modal-dismiss text-dark",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.dismiss()
                          }
                        }
                      },
                      [_c("span", { staticClass: "fa fa-times" })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mx-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 plant-image d-flex align-items-center justify-content-center p-0",
                          style: _vm.plantImageStyle
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.plantImageUrl,
                              alt: _vm.plantDetails.BotanicalName + " Image"
                            }
                          }),
                          _vm._v(" "),
                          _vm.plantDetails.PictureCreditText
                            ? _c("p", { staticClass: "picture-credit" }, [
                                _vm._v(
                                  _vm._s(_vm.plantDetails.PictureCreditText)
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.plantImageUrl
                            ? _c("span", [_vm._v("No Image")])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6 plant-meta pt-2" },
                        [
                          _c("p", { staticClass: "h1 title" }, [
                            _vm._v(_vm._s(_vm.plantDetails.BotanicalName))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "my-2" }, [
                            _vm._v(_vm._s(_vm.plantDetails.Description))
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-success w-100 add-to-favorites px-3",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.toggleFavorite()
                                }
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "fa mr-1",
                                class: {
                                  "fa-heart-o": !_vm.favorited,
                                  "fa-heart": _vm.favorited
                                }
                              }),
                              _vm._v(
                                " Add to Favorites\n                            "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body p-1 p-md-2" }, [
                    _c(
                      "ul",
                      { staticClass: "list-group" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _vm._l(_vm.plantMetaKeys, function(key) {
                          return _c(
                            "li",
                            {
                              key: key,
                              staticClass: "list-group-item plant-meta"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between plant-meta-item"
                                },
                                [
                                  _c("span", { staticClass: "mr-1" }, [
                                    _vm._v(_vm._s(_vm.plantMetaMap[key]))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-right" }, [
                                    _vm._v(
                                      _vm._s(_vm.plantDetails[key] || "N/A")
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "list-group-item plant-attributes" },
                          [
                            _c("span", { staticClass: "d-block" }, [
                              _vm._v("Attributes")
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "plant-attributes-text" },
                              [_vm._v(_vm._s(_vm.plantAttributesText))]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer justify-content-center" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "text-muted",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.dismiss()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Close\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.plantDetails
              ? _c("div", { staticClass: "p-2 text-center text-muted" }, [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v("Loading plant details...")
                  ])
                ])
              : _vm._e()
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "modal-backdrop fade",
      class: { show: _vm.show, "d-none": !_vm.show },
      on: {
        click: function($event) {
          return _vm.dismiss()
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list-group-item" }, [
      _c("p", { staticClass: "h2 my-1" }, [_vm._v("Plant Details")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }